  <template>
   <b-modal style="padding:15px" size="lg" id="EditWheatTypeModal" ref="modal" title="Edit Wheat Type" ok-title="Submit" cancel-title="Close" 
      @hidden= "resetModal()" @show= "updateModal()" @ok= "handleOk" :ok-disabled = "this.$refs.EditWheatTypeForm != undefined ? !this.$refs.EditWheatTypeForm.checkValidity() : true">
        <form ref="EditWheatTypeForm" @submit.stop.prevent= "handleSubmit">
          <div class="row">
           
            <div class="col-md-12">
               <b-form-group  label="Name" label-for="type-input" autocomplete="off">
                <b-form-input id="type-input" v-model= "TypeName"  required></b-form-input>
              </b-form-group>
            </div>
          </div>     
        </form>
      </b-modal>
      </template>

      <script>
import axios from 'axios';
// import config from '../config.js';

export default {
    name: 'EditWheatType',
    data(){
        return{
          moduleName:'Edit Wheat Type',  
          TypeName:'',
          Id:null 
		}
  },

 props:
 {
   wheatType:{
     type:Object,
     default:null
   }
 },


methods:{
  
   editType(){ 
        
     axios.post('/wheattype/Edit', 
      {"Id":this.Id,"TypeName":this.TypeName
      })
      .then(res=>{
            if(res.data.status == 1)
            {
                this.$bvModal.msgBoxOk('Wheat type has been Edited successfully!', {
                title: 'Confirmation',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'success',
                headerClass: 'p-10 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
                });
                 this.$router.go();

              
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },

   checkFormValidity() {
        const valid = this.$refs.EditWheatTypeForm.checkValidity()
        // this.usernameState = valid
        return valid
      },
     
      resetModal() {
        this.CompanyName='';
        this.Id = '';  
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        } 
        this.editType()
       
        this.$nextTick(() => {
          //this.$router.go('/phones')
          this.$bvModal.hide('EditWheatTypeModal')
        
        })
      },

   updateModal()
  {
      console.log(this.wheatType)
        this.TypeName= this.wheatType.name;
        this.Id = this.wheatType.id; 
    },

  }
	

}
</script>
